const Google_API_URL = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d39843.962306017405!2d-2.36453!3d51.38012645!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487178a6743ee12d%3A0x138b27d0d66d9a09!2sBath%2C%20UK!5e0!3m2!1sen!2sbg!4v1693904408435!5m2!1sen!2sbg"

export default Google_API_URL